import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { templateApi } from '@/api/templateApi'
import { TemplateHelp } from '@/types/template-help'

export type TemplateHelpData = Record<number, TemplateHelp>

class TemplatesDictionariesCachedService extends BaseCachedDataService<TemplateHelpData> {
    constructor () {
        super({})
    }

    async loadData () {
        const _data = await templateApi.getWidgetsTemplateHelps()
        return this.data = (_data || []).reduce<TemplateHelpData>((acc, item) => {
            if (Object.keys(item.Help).length) {
                acc[item.TemplateID] = item
            }
            return acc
        }, {})
    }
}

export default new TemplatesDictionariesCachedService()
